(function (SSC) {
  'use strict';

  var focusReturn = new Map();
  var trapCleanups = new Map();

  SSC.formatMoney = function (cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
      style: 'currency', currency: SSC.currency || 'BRL'
    }).format((Number(cents) || 0) / 100);
  };

  SSC.toast = function (message) {
    var toast = document.querySelector('[data-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function () { toast.classList.remove('is-visible'); }, 4200);
  };

  function focusables(container) {
    return Array.prototype.slice.call(container.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'));
  }

  function trapFocus(container) {
    function onKeydown(event) {
      if (event.key !== 'Tab') return;
      var items = focusables(container);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', onKeydown);
    var first = focusables(container)[0];
    if (first) window.requestAnimationFrame(function () { first.focus(); });
    return function () { container.removeEventListener('keydown', onKeydown); };
  }

  function headerTrigger(name) {
    return document.querySelector('.site-header [data-drawer-open="' + name + '"]');
  }

  function closeDrawer(name, keepFocus) {
    var drawer = document.querySelector('[data-drawer="' + name + '"]');
    if (!drawer) return;
    drawer.removeAttribute('data-state');
    drawer.setAttribute('aria-hidden', 'true');
    if (trapCleanups.has(name)) { trapCleanups.get(name)(); trapCleanups.delete(name); }
    var trigger = headerTrigger(name) || focusReturn.get(name);
    if (trigger && trigger.setAttribute) trigger.setAttribute('aria-expanded', 'false');
    if (!keepFocus) {
      var origin = focusReturn.get(name);
      focusReturn.delete(name);
      if (origin && document.contains(origin) && !origin.closest('[aria-hidden="true"]')) origin.focus();
    }
    document.body.classList.remove('is-locked');
  }

  function openDrawer(name, origin) {
    var drawer = document.querySelector('[data-drawer="' + name + '"]');
    if (!drawer) return;
    document.querySelectorAll('[data-drawer][data-state="open"]').forEach(function (open) {
      if (open !== drawer) closeDrawer(open.getAttribute('data-drawer'), true);
    });
    var trigger = headerTrigger(name) || document.querySelector('[data-drawer-open="' + name + '"]');
    focusReturn.set(name, origin || trigger || document.activeElement);
    drawer.setAttribute('data-state', 'open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    if (trapCleanups.has(name)) trapCleanups.get(name)();
    trapCleanups.set(name, trapFocus(drawer));
  }

  SSC.openDrawer = openDrawer;
  SSC.closeDrawer = closeDrawer;

  document.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('[data-drawer-open]');
    var closeTrigger = event.target.closest('[data-drawer-close]');
    if (openTrigger) {
      event.preventDefault();
      var name = openTrigger.getAttribute('data-drawer-open');
      var origin = headerTrigger(name) || openTrigger;
      if (closeTrigger) closeDrawer(closeTrigger.getAttribute('data-drawer-close'), true);
      openDrawer(name, origin);
      return;
    }
    if (closeTrigger) closeDrawer(closeTrigger.getAttribute('data-drawer-close'));

    var quickToggle = event.target.closest('[data-quick-toggle]');
    if (quickToggle) {
      var panel = document.getElementById(quickToggle.getAttribute('aria-controls'));
      if (panel) {
        panel.hidden = !panel.hidden;
        quickToggle.setAttribute('aria-expanded', String(!panel.hidden));
      }
    }

    var viewMode = event.target.closest('[data-view-mode]');
    if (viewMode) {
      var grid = document.querySelector('[data-collection-results] .product-grid');
      if (grid) grid.classList.toggle('product-grid--dense');
      viewMode.setAttribute('aria-pressed', viewMode.getAttribute('aria-pressed') !== 'true' ? 'true' : 'false');
    }

    var hotspot = event.target.closest('[data-hotspot-trigger]');
    if (hotspot) {
      var hotspotId = hotspot.getAttribute('data-hotspot-trigger');
      var hotspotCard = document.querySelector('[data-hotspot-card="' + hotspotId + '"]');
      document.querySelectorAll('[data-hotspot-card]').forEach(function (card) { if (card !== hotspotCard) card.hidden = true; });
      document.querySelectorAll('[data-hotspot-trigger]').forEach(function (trigger) { if (trigger !== hotspot) trigger.setAttribute('aria-expanded', 'false'); });
      if (hotspotCard) { hotspotCard.hidden = !hotspotCard.hidden; hotspot.setAttribute('aria-expanded', String(!hotspotCard.hidden)); }
    }
    var hotspotClose = event.target.closest('[data-hotspot-close]');
    if (hotspotClose) {
      var closeCard = document.querySelector('[data-hotspot-card="' + hotspotClose.getAttribute('data-hotspot-close') + '"]');
      if (closeCard) closeCard.hidden = true;
      var closeTrigger = document.querySelector('[data-hotspot-trigger="' + hotspotClose.getAttribute('data-hotspot-close') + '"]');
      if (closeTrigger) closeTrigger.setAttribute('aria-expanded', 'false');
    }

    var accordion = event.target.closest('[data-accordion-trigger]');
    if (accordion) {
      var accordionPanel = document.getElementById(accordion.getAttribute('aria-controls'));
      var expanded = accordion.getAttribute('aria-expanded') === 'true';
      accordion.setAttribute('aria-expanded', String(!expanded));
      if (accordionPanel) accordionPanel.hidden = expanded;
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('[data-drawer][data-state="open"]');
    if (open) closeDrawer(open.getAttribute('data-drawer'));
  });

  function reveal() {
    var items = document.querySelectorAll('[data-reveal]');
    if (!('IntersectionObserver' in window)) { items.forEach(function (item) { item.classList.add('is-visible'); }); return; }
    var observer = new IntersectionObserver(function (entries, io) {
      entries.forEach(function (entry) { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); } });
    }, { rootMargin: '0px 0px -12% 0px' });
    items.forEach(function (item) { observer.observe(item); });
  }
  reveal();
})(window.SSC || (window.SSC = {}));
